import { render, staticRenderFns } from "./SOA.vue?vue&type=template&id=64302a3b&scoped=true"
import script from "./SOA.vue?vue&type=script&lang=js"
export * from "./SOA.vue?vue&type=script&lang=js"
import style0 from "./SOA.vue?vue&type=style&index=0&id=64302a3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64302a3b",
  null
  
)

export default component.exports